import { MarkerCollectionModel } from '@/models/marker/marker';
import { RouteLessonsModel, RouteMilestoneModel, SuggestionsModel } from '@/models/marker/reroute';
import { markersAPI } from '@/providers/apis/markers/markers';
import { searchAPI } from '@/providers/apis/search/search';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import RerouteRules from '../reroute-rules/reroute-rules';
import RerouteSuggestion from '../reroute-suggestion/reroute-suggestion';
import SuggestionListPanel from '../suggestion-list-panel/suggestion-list-panel';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'milestone-view',
    components : {
        'reroute-suggestion': RerouteSuggestion,
        'suggestion-panel': SuggestionListPanel,
        'rule-panel': RerouteRules,
    },
})

export default class MilestoneViewComponent extends Vue {

    private get milestoneData() {
        return this.prevItem ? this.storedData : this.generateRouteList;
    }

    @Prop({default: 'element-1'})
    public elementId!: string;

    @Prop()
    public resourceType: any;

    @Prop()
    public userId: any;

    @Prop()
    public isStruggleStudent: any;

    public generatorList: any = [];

    // -------------------------------------------------------------
    // Properties

    @Prop()
    private prevItem!: boolean;

    @Prop()
    private generateRouteList!: RouteMilestoneModel[];

    private showSuggestion: boolean = true;

    @Prop()
    private currentRoute!: boolean;

    @Prop({default: true})
    private isJourneyLoaded!: boolean;

    @Prop()
    private suggestedContent!: any;

    @Prop()
    private selectedLesson: any;

    private activeLesson: any = null;

    private storedData: RouteMilestoneModel[] = [];

    private suggestedItems: any = [];

    private activeStats: any = {};

    private activeIndex: any = 0;

    @Prop()
    private isHideInfo!: boolean;

    @Prop()
    private selectedIndex: any;

    @Prop({default: false})
    private isHideMilestone!: boolean;

    @Prop()
    private isContentTab!: boolean;

    @Prop()
    private showRoute!: boolean;

    @Prop()
    private activeSubject: any;

    private searchTerms: string = '';

    @Prop()
    private isContent: any;

    @Watch('resourceType')
    public onSearch() {
      if (this.activeSubject && this.activeLesson && this.isContent) {
      const params: any = {
          learnerId: this.userId,
          competencyCode: this.activeLesson.compCode,
          contentType: this.resourceType,
          subjectCode: this.activeSubject.code,
          language: 'english',
          limit: 5,
        };
      if (this.userId) {
        searchAPI.fetchGeneratorAI(params).then((data: any) => {
          if (data && data.length) {
            this.$set(this, 'generatorList', data);
          }
        });
      }
    }
    }

    @Watch('isJourneyLoaded', {deep: true})
    private loadedSuggestions() {
        this.onSearch();
        const activeLesson = this.activeLesson;
        let suggestionContent: SuggestionsModel[]  = [];
        if (activeLesson && this.suggestedContent && this.currentRoute) {
             suggestionContent = this.suggestedContent[activeLesson.lessonId] || [];
        }
        this.suggestedItems = suggestionContent;
    }

    @Watch('selectedLesson')
    private onChangeLesson() {
        if (this.selectedLesson) {
            this.locateLessonContent();
        }
    }

    // --------------------------------------------------------------
    // Hooks

    private created() {
        this.onChangeLesson();
        this.loadedSuggestions();
        if (this.prevItem) {
            this.storedData = this.generateRouteList;
        }
        if (this.generateRouteList && this.generateRouteList[0] && this.generateRouteList[0].lessons) {
          let isFound: any = false;
          this.generateRouteList.map( (list: any, index: any) => {
            list.lessons.map( (lesson: any) => {
              if (this.isStruggleStudent && lesson.compDisplayCode === '5.OA.2') {
                isFound = true;
                this.onSelectMilestone(index);
                this.onSelectLesson(lesson, index);
              }

              if (!this.isStruggleStudent && lesson.compDisplayCode === '7.G.1') {
                isFound = true;
                this.onSelectMilestone(index);
                this.onSelectLesson(lesson, index);
              }
            });
          });
          if (!isFound) {
            this.onSelectLesson(this.generateRouteList[0].lessons[0], 0);
          }
        }
    }


    // -------------------------------------------------------------
    // Actions
    private onShowMetadata(assessmentData: any) {
        this.$emit('onShowMetadata', assessmentData);
    }

    private onSelectCompetency() {
        this.$emit('onSelectCompetency', {});
    }

    private onSuggestion(suggestion: SuggestionsModel) {
        const lessonId = this.activeLesson.lessonId;
        const suggestionIndex = this.suggestedContent[lessonId].indexOf(suggestion);
        if (suggestionIndex !== -1) {
            this.suggestedContent[lessonId][suggestionIndex].isActive = true;
        }
        this.$set(this.activeStats, lessonId, !this.activeStats[lessonId]);
    }

    private onShowSuggestion() {
        const lessonId = this.activeLesson.lessonId;
        this.$set(this.activeStats, lessonId, !this.activeStats[lessonId]);
    }

    private onPreview(content: any) {
        this.$emit('onShowMetadata', content);
    }

    private onPreviewContent(content: any) {
       this.onLoadCollectionContent(content);
    }

    private onSelectLesson(lesson: RouteLessonsModel, index: any) {
        if (!lesson.collections) {
            this.fetchLessonData(lesson, index);
        } else {
          if (this.isHideMilestone === false) {
            this.$emit('onSelectCompetency', lesson.collections[1], lesson, this.activeIndex);
          }
        }
        this.activeLesson = lesson;
        this.loadedSuggestions();
        this.scrollIntoExpandView();
    }

    private onSelectCollection(collection: MarkerCollectionModel) {
        this.$emit('onSelectCompetency', collection, this.activeLesson, this.activeIndex);
    }

    private onSelectMilestone(milestoneIndex: number) {
        this.activeIndex = milestoneIndex;
    }

    // -------------------------------------------------------------
    // Methods

    private fetchLessonData(lesson: RouteLessonsModel, index: any) {
        const param = {
            lessonId: lesson.lessonId,
        };
        markersAPI.fetchRouteLessons(param).then((content) => {
            this.$set(lesson, 'collections', content);
            if (this.isHideMilestone === false) {
              this.$emit('onSelectCompetency', content[1], lesson, this.activeIndex);
            }
        });
    }

    private locateLessonContent() {
        const selectedLesson = this.selectedLesson;
        const milestoneData = this.milestoneData;
        for (const milestone of milestoneData) {
            const activeLesson = milestone.lessons.find((item) => item.lessonId === selectedLesson.lessonId);
            if (activeLesson) {
                this.onSelectLesson(activeLesson, 0);
                break;
            }
        }
    }

    private onLoadCollectionContent(content: any) {
        const params: any = {
            'q': content.id,
            'flt.collectionType': content.format,
          };

        searchAPI.fetchCollections(params).then((assessmentData) => {
          this.$emit('onShowMetadata', assessmentData.searchResults[0]);
        });
    }

    private scrollIntoExpandView() {
        this.$nextTick(() => {
            setTimeout(() => {
              if (this.$el.querySelector('.milestone-lesson-panel .not-collapsed')) {
                this.$el.querySelector('.milestone-lesson-panel .not-collapsed')!
                    .scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center',
                    });
                  }
            }, 100);
        });
    }
}
